export enum Action {
    Add = 'add',
    Change = 'change',
    Delete = 'delete',
    View = 'view',
    Unknown = 'unknown',
}
